import { useRecoilValue } from 'recoil';
import { ALL_WORKSPACES_PAGES_PERMISSIONS } from '../constants/app';
import { activePagesState, isAllWorkspacesSelect } from '../storage/app';
import { PagePermissionName } from '../types/app';

export function usePage() {
  const activePages = useRecoilValue(activePagesState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);

  const canAccess = (permissionName: PagePermissionName) => {
    if (isAllWorkspacesSelected) {
      return ALL_WORKSPACES_PAGES_PERMISSIONS.includes(permissionName) && activePages.includes(permissionName);
    }
    return activePages.includes(permissionName);
  };

  return { canAccess };
}
